import { useState, useEffect, useRef, useCallback } from "react";
import KeySegmentTable from "./KeySegmentTable";
import styles from '../css/keysegment.module.css'

function Engagement_Segment(props) {
  const [filterBodyToAH, setFilterBodyToAH] = useState([]);
  const [engagementResult, setEngagementResult] = useState([]);
  const controllerRefEng = useRef();

  const displayEngagementData = useCallback(
    async (filBody) => {
      console.log("filBody in disp is", filBody);
      if (controllerRefEng.current) {
        controllerRefEng.current.abort();
      }
      const controller = new AbortController();
      controllerRefEng.current = controller;

      await fetch(
        `${window._env_.UNIFIED_URL}/analytics/keySegment/surge/${props.tenantId}?page=1&limit=5&icp=${props.icpSelected}&filterName=${encodeURIComponent(props.segmentName)}&sortby=&sortType=`,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ filters: filBody }),
          signal: controllerRefEng.current?.signal,
          credentials: "include",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success === true) {
            setEngagementResult(data?.data?.result.slice(0, 5));
            props.setCount(data?.data?.filteredCount)
          } else {
            setEngagementResult([]);
            props.setCount('0')
          }
        })
        .catch((err) => {
          if (err?.message !== "The user aborted a request.") {
            setEngagementResult([]);
            props.setCount('0')
          }
        });
    },
    [props.icpSelected, props.segmentName, props.tenantId]
  );

  useEffect(() => {

      if (props.requestBody && props.segmentName && props.icpSelected) {
        displayEngagementData([...props.requestBody, ...props.specialFilter]);
      }
  }, [
    props.requestBody,
    props.segmentName,
    props.icpSelected,
    displayEngagementData,
  ]);

  return (
    
      <div
        className={styles.keySegmentContainer}
      >
        <KeySegmentTable
          column2={"Engagement"}
          count={props?.count}
          rowsData={engagementResult}
          tabVal={props.tabVal}
          icp={props.icpSelected}
          requestBody={props.requestBody}
          segmentName={props.segmentName}
          filterBodyToAH={filterBodyToAH}
          category={props?.category}
        />
      </div>
    
  );
}

export default Engagement_Segment;
